import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ProductionOrderService, ProductionOrderData, PrClient, Customer } from '../../services/production-order.service';
import { ShipService } from '../../services/ship.service';
import { EmployeeService } from '../../services/employee.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { ProductVntaService, PrVnta } from '../../services/product-vnta.service';
import { toast, MaterializeAction } from 'angular2-materialize';
import { ProductClientService, PrClientData } from '../../services/product-client.service';
import { QuotationFunctionData } from '../../quotation-activity-functions';
import { ActivityService, ActivityId, PdfActivityDisplayLabels } from '../../services/activity.service';
import { UserService } from '../../services/user.service';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { RemissionId, RemissionService } from '../../services/remission.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-display-production-order',
    templateUrl: './display-production-order.component.html',
    styleUrls: ['./display-production-order.component.css', '../../app.component.css']
})

export class DisplayProductionOrderComponent implements OnInit, OnDestroy {

    order: any = {};
    sections: any[] = [];
    generalActivities: any[] =[];

    prClient = {
        id: '',
        code: '',
        version: '',
        barCode: '',
		designComments: '',
		qualityComments: '',
        processOwnerComments: '',
        newVersionMotive: ''
    }
    customer = {
        id: '',
        purchaseOrderNumber: ''
    }

    isoDescription: any = {};

    employees: any = { '': {name:''}};

    customerName: string = '';

    id: string;

    subs: any[] = [];
    subsUnder: any[] = [];

    remSub: Subscription;
    viewRems: boolean = false;
    rems: RemissionId[] = [];

    Math = Math;
    Object = Object;
    PdfActivityDisplayLabels = PdfActivityDisplayLabels;
    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private service: ProductionOrderService,
        private productionOrderData: ProductionOrderData,
        private quotFunctionData: QuotationFunctionData,
        private shipService: ShipService,
        private employeeService: EmployeeService,
        private customerService: CustomerSupplierService,
        private prVntaService: ProductVntaService,
        private prClientService: ProductClientService,
        private activityService: ActivityService,
        private userService: UserService,
        private settings: CatalogsSettingsService,
        private remService: RemissionService,
        private prClientData: PrClientData
    ) {
        this.id = this.activatedRoute.snapshot.paramMap.get('id');

        let setSub = this.settings.getPayrollSettings('1').subscribe(({isoDescriptions: {OdP}}) => {
          setSub.unsubscribe();
          this.isoDescription.OdP = OdP;
        });

        this.subs.push(
            this.service.getProductionOrder(this.id).subscribe(([{prClient, customer, sections=[], generalActivities=[], companyObj, pieceType='', ...orderObj}]) => {
                this.resetSubsUnder();
                let defaultPdfDisplay: ActivityId['pdfDisplay'] = {key1: false, key2: false, key3: false};
                this.order = {
                    pieceType,
                    ...orderObj,
                    statusName: productionOrderData.statusObjects[orderObj.status].name,
                    companyImageURL: companyObj.imageURL,
                    companyName: companyObj.name,
                    companyWebPage: companyObj.webPage || ''
                }
                console.log(this.order);
                
                this.sections = sections;
                this.generalActivities = generalActivities;
                this.subsUnder.push( this.customerService.getCustomerSupplier(customer.id).subscribe(c => { this.customerName = c.name }) );

                this.prClient = {...prClient};
                this.customer = {...customer};
                
                if(orderObj.shipId)
                this.subsUnder.push(
                    this.shipService.getShip(orderObj.shipId).subscribe(([shipObj]) => {
                        this.order.shipName = shipObj.name + ' - ' + shipObj.description;
                    })
                ); 
                if(orderObj.employeeId)
                this.subsUnder.push(
                    this.employeeService.getEmployee(orderObj.employeeId).subscribe(employeeObj => {
                        this.order.employeeName = employeeObj.name + ' ' + employeeObj.lastName;
                    })
                );
                if(orderObj.prVntaId)
                this.subsUnder.push(
                    this.prVntaService.getPrVnta(orderObj.prVntaId).subscribe(([prVnta]) => {
                        this.order.prVntaName = prVnta.name;
                    })
                );
                if(customer.id){
                    if(this.remSub){
                        this.remSub.unsubscribe();
                        this.remSub = undefined;
                    }
                    this.remSub = this.remService.getRemissions({customerId: customer.id}).subscribe(rems => {
                        this.rems = rems.filter(({productionOrder = {id: ''}}) => {
                            return productionOrder.id == this.id;
                        }).map(({billObjs=[], ...rem}) => {
                            rem.bills = billObjs.length ? billObjs.map(({folio}) => folio).join(', ') : 'N.A';
                            return rem;
                        });
                    });
                }

                let employeeSub = this.employeeService.getEmployees({deleted: true}).subscribe(employees => {
                    employeeSub.unsubscribe();

                    employees.map(({id$, name, lastName, ...employee}) => {
                        this.employees[id$] = { name: `${name} ${lastName}`, ...employee };
                    });

                    this.order.sections = sections.map(({activities, ...section}) => {
                        return {
                            activities: activities.map(a => a.quantityPricesFunction != 'pegado' || !a.unique ? a : {...a, unique: {...a.unique, pasteType: (prClientData.pasteTypeSelect[a.unique.pasteType] || {}).name || ''}}),
                            ...section
                        }
                    });
                    this.order.sections.map(({inks: {front, back}, ...section}, sIndex) => {
                        section.frontInk = front.reduce((acc, cur, index) => acc + (index && cur ? ', ' : '') + cur, '');
                        section.backInk = back.reduce((acc, cur, index) => acc + (index && cur ? ', ' : '') + cur, '');
                        section.activities.map(({ employeeMade='', employeeQuality='', employeeProduction='', prices, status='wait', actId, ...activity},aIndex) => {
                            let o: any = {
                                employeeMade: this.employees[employeeMade].name,
                                employeeQuality: this.employees[employeeQuality].name,
                                employeeProduction: this.employees[employeeProduction].name,
                                status: productionOrderData.activityStatusObjects[status].name,
                                prices: prices.reduce( (acc, cur, cIndex) => {
                                    acc[quotFunctionData.functionData[activity.quantityPricesFunction].labels[cIndex]] = cur;
                                    return acc;
                                }, {}),
                                pdfDisplay: defaultPdfDisplay,
                                ...activity
                            }
                            if(actId) var sub = this.activityService.getActivity(actId).subscribe((act: any) => {
                                sub.unsubscribe();
                                o.fileURL = act.fileURL || '';
                                o.appliesOdP = act.appliesOdP
                            });
                            else o.fileURL = '';
                            if(o.quality && o.quality.userId) var userSub = userService.getUser(o.quality.userId).subscribe(user => {
                                userSub.unsubscribe();
                                o.employeeQuality = `${user.name} ${user.lastName}`;
                                o.quality = true;
                            });
                            section.activities[aIndex] = o;
                        } );
                        this.order.sections[sIndex] = section;
                    } );
                    this.order.generalActivities = generalActivities.map(({ employeeMade='', employeeQuality='', employeeProduction='', prices, status='wait', actId, ...activity}) => {
                        let o: any = {
                            employeeMade: this.employees[employeeMade].name,
                            employeeQuality: this.employees[employeeQuality].name,
                            employeeProduction: this.employees[employeeProduction].name,
                            status: productionOrderData.activityStatusObjects[status].name,
                            prices: prices.reduce( (acc, cur, cIndex) => {
                                acc[quotFunctionData.functionData[activity.quantityPricesFunction].labels[cIndex]] = cur;
                                return acc;
                            }, {}),
                            pdfDisplay: defaultPdfDisplay,
                            ...activity
                        }
                        if(actId) var sub = this.activityService.getActivity(actId).subscribe((act: ActivityId) => {
                            sub.unsubscribe();
                            o.fileURL = act.fileURL || '';
                        });
                        else o.fileURL = '';
                        return o;
                    } );
                });
				
            })
        );
    }

    ngOnInit() {
        window["log"] = () => console.log(JSON.stringify(this.order.sections[0].activities[1]));
    }
    ngOnDestroy(){
        this.subs.map((sub, index) => {
            this.subs[index].unsubscribe();
        });
        this.resetSubsUnder();
    }
    resetSubsUnder(){
        this.subsUnder.map((sub, index) => {
            if(this.subsUnder[index]) this.subsUnder[index].unsubscribe();
        });
        this.subsUnder = [];

    }

    onExit(){
        if(this.service.returnFromViewTo == 'lite') this.service.windowReplace('liteSearch');
        else this.service.windowReplace('read');
    }
    onEdit(){
        this.router.navigate(['/edt_production_order/' + this.id + '/' + this.customer.id]);
    }

    onPdf({isProd}){
        /* if(1){
            console.log(this.order)
            console.log(JSON.parse(this.pdfJson));
            return 1;
        } */
        
        if (this.order.companyName == 'ILUSA'){
            console.log("La compañia es ILUSA, ENviar PDF a su propia version");
            
            if(!this.prClient.id) return window[isProd ? 'sendProductionOrderToPhpIlusa' : 'sendProductionOrderComprasToPhpIlusa'](false);
            let sub = this.prClientService.getPrClient(this.prClient.id).subscribe(([prClient]) => {
                sub.unsubscribe();
                console.log(prClient)
                if(!prClient.isLastVersion) return toast('El producto de cliente no es última versión.', 3000);
                if(prClient.designStatus == 'Normal' && prClient.qualityStatus == 'Normal' || !isProd) window[isProd ? 'sendProductionOrderToPhpIlusa' : 'sendProductionOrderComprasToPhpIlusa'](false);
                else toast("No se puede mandar a imprimir si el estatus de calidad o diseño estan pendientes.", 3000);
            });
            
        }else{
            //if(1) return console.log(this.order.sections[0].activities);
            if(!this.prClient.id) return window[isProd ? 'sendProductionOrderToPhp' : 'sendProductionOrderComprasToPhp'](false);
            let sub = this.prClientService.getPrClient(this.prClient.id).subscribe(([prClient]) => {
                sub.unsubscribe();
                if(!prClient.isLastVersion) return toast('El producto de cliente no es última versión.', 3000);
                if(prClient.designStatus == 'Normal' && prClient.qualityStatus == 'Normal' || !isProd) window[isProd ? 'sendProductionOrderToPhp' : 'sendProductionOrderComprasToPhp'](false);
                else toast("No se puede mandar a imprimir si el estatus de calidad o diseño estan pendientes.", 3000);
            });
        }
    }

    onReq(){
        let prCmpas: any[] = this.sections.reduce((acc, cur) => [
            ...acc,
            ...cur.activities.map(a => ({sPiece: cur.pieceInSize, sSize: cur.sizeInPaper, ...a}) )
        ], []).filter(({unique=<any>{}}) => unique.prCmpaId).map(({unique, sPiece, sSize}) => ({
            name: unique.prCmpaDescription,
            quantity: Math.ceil((this.order.quantity/sPiece || 1)*((100+(unique.merma||0))/100)/sSize || 0),
            productRef: unique.prCmpaId
        }));
        if(!prCmpas.length) return toast('No se han seleccionado productos de sustrato.', 3000);
        localStorage.odpAuto = JSON.stringify({odp: this.id, prs: prCmpas});
        this.router.navigate(['/add_purchase_request']);
    }

    onRem(){
        let { status } = this.order;
        if(status != 'key2' && status != 'key3' && status != 'key4') return toast(`La orden de produccion debe de estar en los siguientes estatus:${
            ( (...keys) => {
                let str = '';
                for(let key of keys) str += `<br>* ${this.productionOrderData.statusObjects[key].name}`;
                return str;
            } )('key2', 'key3', 'key4')
        }`, 5000);

        let { id: customerId = '' } = this.customer;
        if(!customerId) toast('Hay un error al generar una remisión para esta orden.', 2000);
        localStorage.odpIdToRem = this.order.id;
        this.router.navigate([`/new_remission/${customerId}`]);
    }
    onViewRem(remId: string){
        localStorage.remBack = `/vw_production_order/${this.order.id}`;
        this.router.navigate([`/vw_remission/${remId}`]);
    }

    get pdfJson(){
        return JSON.stringify({
            folio: this.order.name,
            date: this.order.date || '',
            deliveryDate: this.order.deliveryDate,
            prVntaName: this.order.prVntaName,
            pricePerUnit: this.order.pricePerUnit,
            prClientCode: this.prClient.code,
            prClientVersion: this.prClient.version,
            prClientBarCode: this.prClient.barCode,
            designComments: this.prClient.designComments,
            qualityComments: this.prClient.qualityComments,
            processOwnerComments: this.prClient.processOwnerComments,
            newVersionMotive: this.prClient.newVersionMotive,
            customerName: this.customerName,
            customerPurchaseOrder: this.customer.purchaseOrderNumber,
            shortDescription: this.order.shortDescription,
            longDescription: this.order.longDescription,
            monitor: this.order.monitor,
            status: this.order.statusName,
            printData: this.order.printData,
            quantity: this.order.quantity,
            employeeName: this.order.employeeName,
            shipName: this.order.shipName,
            sections: this.order.sections,
            generalActivities: this.order.generalActivities,
            merma: this.order.merma,
            pieceType: this.order.pieceType,
            notes: this.order.notes,

            companyImgUrl: this.order.companyImageURL,
            companyName: this.order.companyName,
            companyIsoDescription: this.isoDescription.OdP

        });
        
    }

    //////////////////////////////////////////////////////////////////////////SECTION
    
	currentSectionTab: number;
    currentSectionShowing: boolean;
    
    changeSectionTab(index) {
        if(this.currentSectionTab == index) this.currentSectionShowing = !this.currentSectionShowing;
        else{
            this.currentSectionTab = index;
            this.currentSectionShowing = true;
        }
    }
    
      get inks(){ return [...Array(8)].map((u, i) => "") }
      //////////////////////////////////////////////////////////////////////////SECTION
    
    //////////////////////////////////////////////////////////////////////////ACTIVITY

    ///////////////////////////////////////////////QUALITY
	quality = {...this.productionOrderData.defaultQuality};
	modalActionsQuality = new EventEmitter<string|MaterializeAction>();
    modalParamsQuality = [{dismissible: true}];
    
    curQualityAct: any = {};
    qualityUser: string = '';
    openModalQuality(isGeneral: boolean, index: number, name: string) {
        this.qualityUser = name;
        this.curQualityAct = {
            ...(isGeneral ? this.generalActivities : this.sections[this.currentSectionTab].activities)[index],
            isGeneral, index
        }
        let qpFunction = this.curQualityAct.quantityPricesFunction
        this.quality[qpFunction] = { ...this.productionOrderData.defaultQuality[qpFunction], ...this.curQualityAct.quality, /* userId: this.authService.currentUser.id */ };
        this.modalActionsQuality.emit({ action: 'modal', params: ['open'] });
    }
    closeModalQuality() {
        this.modalActionsQuality.emit({ action: 'modal', params: ['close'] });
    }

    ///////////////////////////////////////////////QUALITY
    //////////////////////////////////////////////////////////////////////////ACTIVITY

}
